import { _Environment } from "./core";

/**
 * Environment is used to provide vars declared in .env
 * All of react env variable must be prefixed by REACT_APP_...
 * This service allows you to access env variable without prefix REACT_APP_
 */
export default _Environment;